import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Input, Table, Tooltip } from "antd";
import { PlusOutlined, EditOutlined, AuditOutlined } from "@ant-design/icons";
import axios from "axios";
import CommissaryLayout from "../../layout/CommissaryLayout";
import CommissartAddMerchant from "./CommissartAddMerchant";
import { UserInfo } from "../../../context";
import CommissaryMerchantEdit from "./CommissaryMerchantEdit";
import { useNavigate } from "react-router-dom";

const CommissaryMerchants = () => {
  const [commissaryList, setCommissaryList] = useState({
    data: [],
    ready: false,
  });
  const [loading, setLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [editDrawer, setEditDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "Business Name",
      dataIndex: "business_name",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Registered Name",
      dataIndex: "fullname",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Address",
      dataIndex: "address",
      filters: [
        {
          text: "BUTUAN CITY (Capital)",
          value: "BUTUAN CITY (Capital)",
        },
        {
          text: "CITY OF PANABO",
          value: "CITY OF PANABO",
        },
        {
          text: "CITY OF TAGUM (Capital)",
          value: "CITY OF TAGUM (Capital)",
        },
        {
          text: "DAVAO CITY",
          value: "DAVAO CITY",
        },
      ],
      onFilter: (value, record) => record.address.includes(value),
      ellipsis: true,
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
          }}
        >
          {text}
        </p>
      ),
      // render: (text) => <p style={{ textTransform: "uppercase" }}>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: window.innerWidth > 575 ? "auto" : 90 }}>
          <Tooltip title="Edit">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setEditDrawer(true);
              }}
              icon={<EditOutlined />}
              style={{ marginRight: 10 }}
            />
          </Tooltip>

          <Tooltip title="Merchant Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                navigate(`/merchants/${text.id}/${text.user_id}`);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/commissary/merchant-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setCommissaryList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantList();
  }, [getMerchantList]);

  const searchable = commissaryList.data.filter((data) => {
    return data.business_name.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  return (
    <CommissaryLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            placeholder="Search business name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
        >
          Add Merchant
        </Button>
      </div>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openDrawer && (
        <CommissartAddMerchant
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantList={() => getMerchantList()}
        />
      )}

      {editDrawer && (
        <CommissaryMerchantEdit
          open={editDrawer}
          close={() => setEditDrawer(false)}
          setLoading={setLoading}
          getMerchantList={() => getMerchantList()}
          selectedData={selectedData}
        />
      )}
    </CommissaryLayout>
  );
};

export default CommissaryMerchants;
